// removed by extract-text-webpack-plugin
module.exports = {"wrapper-link-page":"magazines_132Pg","input-pages":"magazines_1P3pi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LinkPage/styles.scss
// module id = 1125
// module chunks = 1